// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userProfilePage_title__6IsNa {
  margin-bottom: 28px;

  color: #13151A;

  font-size: 22px;
  line-height: 22px;
}

.userProfilePage_subtitle__f5q8c {
  margin-bottom: 3px;

  color: #13151A;
  border-bottom: 1px solid #eeeff2;

  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.userProfilePage_field__Wc2zZ {
  margin-right: 10px;

  color: #959eab;

  font-size: 14px;
  line-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profile/userProfilePage.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;;EAEnB,cAAc;;EAEd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;EACd,gCAAgC;;EAEhC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".title {\n  margin-bottom: 28px;\n\n  color: #13151A;\n\n  font-size: 22px;\n  line-height: 22px;\n}\n\n.subtitle {\n  margin-bottom: 3px;\n\n  color: #13151A;\n  border-bottom: 1px solid #eeeff2;\n\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.field {\n  margin-right: 10px;\n\n  color: #959eab;\n\n  font-size: 14px;\n  line-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `userProfilePage_title__6IsNa`,
	"subtitle": `userProfilePage_subtitle__f5q8c`,
	"field": `userProfilePage_field__Wc2zZ`
};
export default ___CSS_LOADER_EXPORT___;
